<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="Group 852">
			<path
				id="Vector"
				d="M19.8 10.2272C19.8 9.54746 19.7449 8.86404 19.6273 8.19531L10.1953 8.19531V12.046H15.5966C15.3724 13.2879 14.6523 14.3865 13.5977 15.0847L13.5977 17.5832H16.8201C18.7124 15.8416 19.8 13.2695 19.8 10.2272Z"
				fill="#4285F4"
			/>
			<path
				id="Vector_2"
				d="M10.1938 19.9976C12.8907 19.9976 15.1651 19.1121 16.8222 17.5835L13.5998 15.085C12.7033 15.6949 11.5459 16.0403 10.1974 16.0403C7.58867 16.0403 5.37672 14.2803 4.58307 11.9141H1.25781L1.25781 14.4898C2.95535 17.8665 6.41288 19.9976 10.1938 19.9976Z"
				fill="#34A853"
			/>
			<path
				id="Vector_3"
				d="M4.58061 11.92C4.16174 10.678 4.16174 9.33324 4.58061 8.09132V5.51562L1.25903 5.51562C-0.159259 8.34118 -0.159259 11.6701 1.25903 14.4957L4.58061 11.92Z"
				fill="#FBBC04"
			/>
			<path
				id="Vector_4"
				d="M10.1938 3.95792C11.6194 3.93587 12.9973 4.47232 14.0297 5.45704L16.8847 2.60209C15.0769 0.904557 12.6776 -0.0287207 10.1938 0.000673866C6.41288 0.000673866 2.95535 2.13178 1.25781 5.51216L4.5794 8.08785C5.36938 5.71792 7.58499 3.95792 10.1938 3.95792Z"
				fill="#EA4335"
			/>
		</g>
	</svg>
</template>
